import React from 'react';

const Collapse = ({ title, children }) => {
    const [show, setShow] = React.useState(true);

    return (
        <React.Fragment>
            <div id="Collapse" className="bg-white" style={{ width: 250 }}>
                <div className="p-4 flex justify-between">
                    <div className="font-semibold">{title}</div>
                    <div className="pointer" onClick={() => setShow(!show)}>V</div>
                </div>
                {show && (
                    <div className="p-4 border-t" style={{ minHeight: 300 }}>
                        {children}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default Collapse;